import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {clientApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data, loadData}) => {
    const {setLoading, setMessageBox} = useGlobalStates()

    const handleOk = () => {
        setLoading(true)
        clientApi
            .updateClient(data?.id, {status: 'deactivated'})
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Client Deactivated',
                    description: `${data?.first_name}'s account has been deactivated. You will no longer be able to schedule them.`,
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Deactivate "${data?.first_name}"'s Account?`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Are you sure you want to deactivate this client’s account? Once deactivated, you will no longer be able to schedule or billing
                        for them.
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={handleOk}>
                            Deactivate Account
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
